import { createThunkEffect } from "../../utilities/ActionUtility";
import * as ProductsEffect from "./ProductsEffect";

export const REQUEST_PRODUCTS = "ProductsEffect.REQUEST_PRODUCTS";
export const REQUEST_PRODUCTS_FINISHED = "ProductsEffect.REQUEST_PRODUCTS_FINISHED";

export function requestProducts() {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_PRODUCTS, ProductsEffect.requestProducts);
    };
}

export const REQUEST_EDIT_PRODUCT = "ProductsEffect.REQUEST_EDIT_PRODUCT";
export const REQUEST_EDIT_PRODUCT_FINISHED = "ProductsEffect.REQUEST_EDIT_PRODUCT_FINISHED";

export function editProduct(productId, config) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_EDIT_PRODUCT, ProductsEffect.editProduct, productId, config);
    };
}

export const REQUEST_PRODUCT_SUBSCRIPTION_TYPES = "ProductsEffect.REQUEST_PRODUCT_SUBSCRIPTION_TYPES";
export const REQUEST_PRODUCT_SUBSCRIPTION_TYPES_FINISHED = "ProductsEffect.REQUEST_PRODUCT_SUBSCRIPTION_TYPES_FINISHED";

export function requestProductSubscriptionTypes(productId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_PRODUCT_SUBSCRIPTION_TYPES, ProductsEffect.requestProductSubscriptionTypes, productId);
    };
}

export const REQUEST_PRODUCT_MODULE_PRICING_LEVELS = "ProductsEffect.REQUEST_PRODUCT_MODULE_PRICING_LEVELS";
export const REQUEST_PRODUCT_MODULE_PRICING_LEVELS_FINISHED = "ProductsEffect.REQUEST_PRODUCT_MODULE_PRICING_LEVELS_FINISHED";

export function requestProductModulePricingLevels(productId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_PRODUCT_MODULE_PRICING_LEVELS, ProductsEffect.requestProductModulePricingLevels, productId);
    };
}